import { chaloupkaCompanies } from '../../../utils/companies'
import { BusinessCompanyDiscount } from '../BusinessCompanyDiscount'
import { BusinessDiscountsWrapper } from '../BusinessDiscountsWrapper'

export const BusinessDiscounts = () => {
  return (
    <BusinessDiscountsWrapper>
      {chaloupkaCompanies.map((company) => {
        if (company.businessDiscounts && company.businessDiscounts.chaloupka) {
          return (
            <BusinessCompanyDiscount
              key={company.id}
              name={company.name}
              discounts={company.businessDiscounts.chaloupka}
            />
          )
        }

        return null
      })}
    </BusinessDiscountsWrapper>
  )
}
